<template>
  <div class="activity-steward-page">
    <div class="hd">只差一步 开始领取</div>
    <div class="panel">
      <div class="panel-title">截屏添加管家 获取领取入口</div>
      <div class="qrcode-box">
        <img class="qrcode" :src="qrcode" alt="">
      </div>
      <div class="steps">
        <div class="step">
          <div class="step-icon">
            <img :src="photoIcon" alt="">
          </div>
          <p class="step-title">长按/截图</p>
          <p class="step-desc">保存二维码</p>
        </div>
        <div class="step-arrow"></div>
        <div class="step">
          <div class="step-icon">
            <img :src="scanIcon" alt="">
          </div>
          <p class="step-title">微信扫一扫</p>
          <p class="step-desc">识别相册内二维码</p>
        </div>
        <div class="step-arrow"></div>
        <div class="step">
          <div class="step-icon">
            <img :src="weixinIcon" alt="">
          </div>
          <p class="step-title">添加管家</p>
          <p class="step-desc">获取领取入口</p>
        </div>
      </div>
      <div class="btn">
        <img :src="weixinBtnIcon" alt="">
        <span>截图后打开微信</span>
      </div>
    </div>
    <div class="panel">
      <div class="panel-title">操作流程动图展示</div>
      <div class="panel-img">
        <img :src="guideIcon" alt="">
      </div>
    </div>
    <div class="ft">
      <img :src="copyrightIcon" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'activitySteward',
  data() {
    return {
      qrcode: require('@/assets/images/qrcode.jpeg'),
      photoIcon: require('@/assets/images/photo.png'),
      scanIcon: require('@/assets/images/scan.png'),
      weixinIcon: require('@/assets/images/weixin.png'),
      weixinBtnIcon: require('@/assets/images/weixin-w.png'),
      copyrightIcon: require('@/assets/icons/copyright.png'),
      guideIcon: require('@/assets/images/steward-guide.gif')
    }
  },
  components: {
  },
  // async mounted() {
  //   await this.weixinAuth()
  //   this.wechatShare({
  //     title: `【特别推荐】限时免费！动画趣讲，横跨千年，30天看懂中华文明发展`,
  //     imgUrl: 'https://mmcb-pub.oss-cn-hangzhou.aliyuncs.com/mmcb-logo.png',
  //     desc: '超长历史跨度，带孩子见证每一个历史的辉煌时刻！',
  //     link: `${window.location.origin}/#/activity/steward`
  //   })
  // },
  methods: {}
}
</script>

<style lang="scss" scoped>
  .activity-steward-page {
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: 34.5px;
    padding-bottom: 49px;
    background-image: url('~@/assets/images/steward-bg.png');
    background-size: 100%;
    background-repeat: no-repeat;
    .hd {
      margin-bottom: 29.5px;
      font-size: 28px;
      line-height: 34.5px;
      text-align: center;
      color: #fff;
      letter-spacing: 0.675px;
      font-weight: 700;
    }
    .ft {
      padding-top: 49px;
      img {
        width: 180px;
        margin: 0 auto;
        display: block;
      }
    }
    .panel {
      width: 335px;
      min-height: 335px;
      background: #fff;
      box-shadow: 0 0 18px 0 rgb(66 66 66 / 10%);
      border-radius: 12px;
      text-align: center;
      margin: 0 auto 12px;
      padding: 16px 16px 37px;
      box-sizing: border-box;
      .panel-title {
        font-size: 18px;
        font-family: PingFangSC,PingFangSC-Semibold;
        font-weight: 600;
        text-align: center;
        color: #333;
        line-height: 18px;
        margin: 14px auto 38px;
      }
      .panel-img {
        img {
          width: 100%;
        }
      }
      .qrcode-box {
        width: 190px;
        height: 190px;
        position: relative;
        margin: 0 auto;
        background-image: url('~@/assets/images/qrcode-box.png');
        background-size: 100% 100%;
        .qrcode {
          width: 188px;
          height: 188px;
          padding: 1px;
        }
      }
      .steps {
        display: flex;
        margin: 30px 0 40px;
        .step {
          width: 100px;
          .step-icon {
            width: 50px;
            height: 50px;
            border-radius: 25px;
            background: #FFF4EA;
            margin: 0 auto;
            img {
              width: 32px;
              height: 32px;
              padding: 9px;
            }
          }
          .step-title {
            font-size: 14px;
            color: #000;
            padding: 10px 0 6px;
          }
          .step-desc {
            font-size: 12px;
            color: #333;
          }
        }
        .step-arrow {
          width: 0;
          height: 0;
          border-top: 5px solid transparent;
          border-left: 7.5px solid #FF8401;
          border-bottom: 5px solid transparent;
          margin-top: 20px;
        }
      }
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 200px;
        height: 40px;
        background: #0aca65;
        border-radius: 20px;
        box-shadow: 0 1px 6px 0 #87f4bb;
        color: #fff;
        font-size: 16px;
        font-family: PingFangSC,PingFangSC-Regular;
        margin: 0 auto;
        img {
          width: 19.5px;
          display: block;
          height: 16px;
          margin-right: 4.5px;
        }
      }
    }
  }
</style>
